<template>
  <!-- モーダル部分  --->
  <div>
    <v-row>
      <v-btn color="orange lighten-5" class="mt-5" @click="open">
        CSS
      </v-btn>
    </v-row>
    <v-dialog v-model="dialog" :max-width="maxWidth">
      <v-card>
        <v-card-actions>
          <v-container>
            <v-card-title>
              CSS設定
              <v-btn
                color=""
                class="ma-2"
                @click="reset"
                :disabled="values.length == 0"
              >
                リセット
              </v-btn>
              <v-btn
                color="primary"
                class="ma-2"
                @click="add"
                :disabled="values.length >= type.length"
              >
                追加
              </v-btn>
            </v-card-title>
            <v-row v-for="(val, i) in values" :key="i">
              <v-col cols="3">
                <v-select
                  label="設定内容"
                  v-model="val.type"
                  item-text="label"
                  item-value="value"
                  :items="getType(val.type)"
                ></v-select>
              </v-col>
              <!--- --->
              <v-col cols="3" v-if="view(val.type, 'color')">
                <v-select
                  label="色"
                  v-model="val.color"
                  :items="$store.state.colors"
                  :background-color="val.color == 'black' ? 'white' : val.color"
                ></v-select>
              </v-col>
              <v-col cols="3" class="mt-5" v-else> 色設定なし</v-col>
              <v-col cols="2" v-if="view(val.type, 'size')">
                <v-select
                  label="サイズ"
                  item-text="label"
                  item-value="value"
                  v-model="val.size"
                  :items="size"
                ></v-select>
              </v-col>
              <v-col cols="2" class="mt-5" v-else> サイズ設定なし</v-col>
              <v-col cols="2" v-if="view(val.type, 'weight')">
                <v-select
                  label="太さ"
                  item-text="label"
                  item-value="value"
                  v-model="val.weight"
                  :items="weight"
                ></v-select>
              </v-col>
              <v-col cols="2" class="mt-5" v-else> 太さ設定なし</v-col>
              <v-col cols="2">
                <v-btn
                  v-if="val.type != 0"
                  color="red white--text"
                  class="mt-4"
                  @click="del(i)"
                >
                  削除
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    params: { type: String, default: "" },
    maxWidth: { type: String, default: "1300px" },
  },
  data() {
    return {
      returnData: {
        value: null,
      },
      values: [],
      valueSet: {
        type: 0,
        color: "black",
        size: 0,
        weight: 0,
      },
      //
      type: [
        { label: "入力文字", value: 1 },
        { label: "枠線", value: 2 },
        { label: "ラベル", value: 3 },
      ],
      //color:[],
      size: [
        { label: "小さめ", value: 15 },
        { label: "普通", value: 0 },
        { label: "少し大きめ", value: 23 },
        { label: "大きめ", value: 30 },
      ],
      weight: [
        { label: "通常", value: 0 },
        { label: "太め", value: 550 },
      ],
      //
      valid: true,
      dialog: false,
    };
  },
  watch: {
    values: {
      handler(value) {
        this.$emit("set", JSON.stringify(value));
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    open() {
      this.dialog = true;
      this.init();
    },
    init() {
      if (this.params == "") {
        this.values.push(JSON.parse(JSON.stringify(this.valueSet)));
      } else {
        this.values = JSON.parse(this.params);
      }
    },
    add() {
      this.values.push(JSON.parse(JSON.stringify(this.valueSet)));
    },
    del(index) {
      this.values.splice(index, 1);
    },
    reset() {
      this.values = [JSON.parse(JSON.stringify(this.valueSet))];
    },
    getType(c) {
      if (typeof this.values.length == "undefined" || this.values.length == 0) {
        return this.type;
      }
      const arr = this.values.map((obj) => obj.type);
      const type = this.type.filter((t) => {
        if (arr.includes(t.value) && t.value != c) {
          return false;
        }
        return true;
      });
      return type;
    },
    view(type, param) {
      switch (type) {
        case 1:
          if (param == "color" || param == "size" || param == "weight") {
            return true;
          }
          break;
        case 2:
          if (param == "color" || param == "weight") {
            return true;
          }
          break;
        case 3:
          if (param == "color" || param == "weight") {
            return true;
          }
          break;
      }
      return false;
    },
  },
};
</script>

<style>
.custom-label-color input {
  color: black !important;
}
</style>
